import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router-dom';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function ListComponents () {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [components, setComponents] = useState([]);

  useEffect(() => {
    api.get('/components')
      .then((res) => {
        setComponents(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  function findComponents () {
    api.get('/components')
      .then((res) => {
        setComponents(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }

  function updateComponent (newValue, oldValue) {
    api.put('/components', { component: newValue })
      .then((res) => {
        setComponents(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Componente atualizado com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }

  function deleteComponent (oldValue) {
    api.delete(`/components/${oldValue._id}`)
      .then((res) => {
        setComponents(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Componente removido com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }
  return (
    <div className="content-list">
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <section className="update">
        <div
          className="update-table"
          onClick={findComponents}
          aria-hidden="true"
        >
          <p>Atualizar</p>
          <FontAwesomeIcon icon={faSyncAlt} size="lg" color="white" />
        </div>
      </section>
      <MaterialTable
        title="Componentes"
        columns={[
          { title: 'Nome', field: 'name' },
          { title: 'Descrição', field: 'description' },
          { title: 'Rota', field: 'route' },
        ]}
        localization={{
          header: {
            actions: 'Oções',
          },
          body: {
            emptyDataSourceMessage: 'Sem dados para mostrar',
            deleteTooltip: 'Remover',
            addTooltip: 'Adicionar Usuário',
            editTooltip: 'Editar',
            editRow: {
              cancelTooltip: 'Cancelar',
              deleteText: 'Tem certeza que deseja remover',
              saveTooltip: 'Confirmar',
            },

          },
          toolbar: {
            searchPlaceholder: 'Buscar',
            searchTooltip: 'Buscar',
          },
        }}
        data={components}
        editable={{
          onRowUpdate: (newValue, oldValue) => new Promise((resolve) => {
            updateComponent(newValue, oldValue);
            setTimeout(() => resolve(), 2000);
          }),
          onRowDelete: (oldValue) => new Promise((resolve) => {
            deleteComponent(oldValue);
            setTimeout(() => resolve(), 2000);
          }),
        }}
      />
    </div>
  );
}
